/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ change: NonNullable<unknown> }} Dashboard_Stats_Sincelasthour2Inputs */

const he_dashboard_stats_sincelasthour2 = /** @type {(inputs: Dashboard_Stats_Sincelasthour2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.change} מהשעה האחרונה`)
};

const en_dashboard_stats_sincelasthour2 = /** @type {(inputs: Dashboard_Stats_Sincelasthour2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.change} since last hour`)
};

/**
* | output |
* | --- |
* | "{change} since last hour" |
*
* @param {Dashboard_Stats_Sincelasthour2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_stats_sincelasthour2 = /** @type {((inputs: Dashboard_Stats_Sincelasthour2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stats_Sincelasthour2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_stats_sincelasthour2(inputs)
	return en_dashboard_stats_sincelasthour2(inputs)
});
export { dashboard_stats_sincelasthour2 as "dashboard_stats_sinceLastHour" }